import { useDeleteCampaignMutation } from '@/entities/campaign/mutation/use-delete-campaign-mutation';
import { requestConfirm } from '@/shared/utils/request-confirm';

export const useDeleteCampaignRequest = (props?: { onSuccess: () => void }) => {
  const deleteCampaignMutation = useDeleteCampaignMutation();

  const onDeleteCampaign = (campaignId: string, campaignName: string) => {
    void requestConfirm({
      title: 'Delete campaign?',
      description: (
        <>
          Are you sure you want to delete "{campaignName}"?
          <br />
          Deleting it will permanently remove this campaign and any collected posts, and this action
          cannot be undone.
        </>
      ),
      confirmButton: {
        children: 'Delete campaign',
        variant: 'destructive',
      },
      onConfirm: async () => {
        await deleteCampaignMutation.mutateAsync(campaignId);
        props?.onSuccess();
      },
    });
  };

  return onDeleteCampaign;
};
